function sphericalCosinus(lat1, lon1, lat2, lon2){
  const radius = 6371e3; // meters
  let dLon = toRad(lon2 - lon1);

  lat1 = toRad(lat1);
  lat2 = toRad(lat2);

  let distance = Math.acos(Math.sin(lat1) * Math.sin(lat2) + Math.cos(lat1) * Math.cos(lat2) * Math.cos(dLon)) * radius;
  return isNaN(distance) ? 0 : distance;
}

function toRad(n) { return n * Math.PI / 180; }

const WIRELESS_PING_DUR_THRESHOLD = 120;//2 min
const RIDE_MAX_INTERVAL = 120; // 2 min
const IDLE_SPD_THRESHOLD = 2;
const ANGLE_THRESHOLD = 45;
const MOTION_SPEED_THRESH = 3;
const ANGLE_CAL_ISSUE_THRESHOLD = 25;
const ANGLE_SPD_THRESHOLD = 40;

function calculateBearing(lat1, lng1, lat2, lng2) {
  const toRad = (deg) => deg * (Math.PI / 180);
  const toDeg = (rad) => rad * (180 / Math.PI);

  const dLon = toRad(lng2 - lng1);
  const y = Math.sin(dLon) * Math.cos(toRad(lat2));
  const x =
    Math.cos(toRad(lat1)) * Math.sin(toRad(lat2)) -
    Math.sin(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.cos(dLon);
  const brng = toDeg(Math.atan2(y, x));

  return (brng + 360) % 360;
}

function computeTLStats(data){
  try{
    if(!data || !data.length) return;

    var sts = Date.now();

    var stats = {
      tps: 0,
      sdt: 0,
      mang: 0,
      dst: 0,
      edt: 0,
      ignOnDur: 0,
      runningTime: 0,
      dur: 0,
      ec: data.length,
      avs: 0,
      ignOnPingCnt: 0,
      ignOffPingCnt: 0,
      motOffPingCnt: 0,
      powerOffPingCnt: 0,
      pingTypCnt: 0,
      ignOffWithMotOnCnt: 0,
      ignOnWithMotOffCnt: 0,
      angleZeroCnt: 0,
      hAngleCnt: 0,
      hAngleWithHSpdCnt: 0
    };

    var runningTimeTs = 0, ignOnTs = 0, durTs = 0;

    var initialLat = 0, initialLon = 0;

    data = data.sort((a, b) => a.ts - b.ts);

    var lastPingIndex = data.length - 1;

    var isSingleDayRide = false;
    var secondDayTs = 0;
    if (new Date(data[0].ts * 1000).getDate() === new Date(data[data.length - 1].ts * 1000).getDate()) {
      isSingleDayRide = true;
    } else {
      secondDayTs = new Date(data[data.length - 1].ts * 1000).setHours(0, 0, 0, 0);
    }

    var prevPing;

    if(data[0].ignition){
      stats.ignOnPingCnt++
      stats.sdt = data[0].ts;
      stats.mang = data[0].ang;
      ignOnTs = data[0].ts;

      if(data[0].lat){
        initialLat = data[0].lat;
        initialLon = data[0].lng;
        stats.tps = data[0].spd;
      }

      if(data[0].spd > IDLE_SPD_THRESHOLD) runningTimeTs = data[0].ts;

      if(!data[0].motion) stats.ignOnWithMotOffCnt++

    }else {
      stats.ignOffPingCnt++;

      if(data[0].motion) stats.ignOffWithMotOnCnt++;

    }

    if(!data[0].mainPower) stats.powerOffPingCnt++;

    if(!data[0].motion) stats.motOffPingCnt++;

    if(!data[0].ang) stats.angleZeroCnt++;
    else if(data[0].ang > ANGLE_CAL_ISSUE_THRESHOLD){
      stats.hAngleCnt++;
      if(data[0].spd && data[0].spd > ANGLE_SPD_THRESHOLD) stats.hAngleWithHSpdCnt++;
    }

    if(!data[0].lat && !data[0].lng) stats.pingTypCnt++;

    for (var i = 1; i < data.length; i++) {

      var currPing = data[i];
      prevPing = data[i - 1];
      if (!("ignition" in currPing)) {
        currPing = Object.assign({}, prevPing, {
          spd: currPing.spd,
          lat: currPing.lat,
          lng: currPing.lng,
          alt: currPing.alt,
          brg: currPing.brg,
          ts: currPing.ts
        });
      }

      if(!currPing.mainPower) stats.powerOffPingCnt++;

      if(!currPing.motion) stats.motOffPingCnt++;

      if(!currPing.ang) stats.angleZeroCnt++;
      else if(currPing.ang > ANGLE_CAL_ISSUE_THRESHOLD) {
        stats.hAngleCnt++;
        if(currPing.spd && currPing.spd > ANGLE_SPD_THRESHOLD) stats.hAngleWithHSpdCnt++;
      }

      if(!currPing.lat && !currPing.lng) stats.pingTypCnt++;

      if(currPing.ignition) {
        stats.ignOnPingCnt++;
        if(!currPing.motion) stats.ignOnWithMotOffCnt++;
      }
      else {
        stats.ignOffPingCnt++;

        if(currPing.motion) stats.ignOffWithMotOnCnt++;

        // resetting as only ignition pings are considered in ignition on duration and running time
        if(ignOnTs){
          stats.ignOnDur += prevPing.ts - ignOnTs;
          ignOnTs = 0;
        }

        if(runningTimeTs){
          stats.runningTime += (prevPing.ts - runningTimeTs);
          runningTimeTs = 0;
        }

      }

      // calculate stats of pings with ignition on and motion on with speed greater than 5 only
      var skip = (currPing.ignition || (currPing.motion && currPing.spd >= MOTION_SPEED_THRESH)) ? false : true;

      if(skip) {
        if(durTs){
          stats.dur += (prevPing.ts - durTs);
          durTs = 0;
        }
        continue;
      }

      const dur = currPing.ts - prevPing.ts;

      // Duration - Duration for which ignition was on or motion is true and speed greater than 5
      if(!durTs) durTs = currPing.ts;
      else{

        if(i === (data.length - 1)){ // last ping
          stats.dur += (currPing.ts - durTs);
        }else if(dur > RIDE_MAX_INTERVAL){
          stats.dur += (prevPing.ts - durTs);
          durTs = currPing.ts;
        }

      }

      if(!currPing.ignition && !currPing.motion) continue;

      // sdt - first ignition on ping
      if(!stats.sdt) stats.sdt = currPing.ts;

      // Top speed
      if(stats.tps < currPing.spd) stats.tps = currPing.spd;

      // Maximum angle
      if(currPing.ang < ANGLE_THRESHOLD && stats.mang < currPing.ang) stats.mang = currPing.ang;

      // edt - last ignition on ping
      stats.edt = currPing.ts;


      // Ignition on duration - Duration for which ignition was on
      if(!ignOnTs) ignOnTs = currPing.ts;
      else if(ignOnTs){
       if(dur > RIDE_MAX_INTERVAL){
          stats.ignOnDur += prevPing.ts - ignOnTs;
          ignOnTs = currPing.ts;
        }else if(i === lastPingIndex){
          stats.ignOnDur += currPing.ts - ignOnTs;
        }
      }

      // Running time - Duration for which ignition was on and speed was greater than 2
      if(currPing.spd > IDLE_SPD_THRESHOLD && i !== lastPingIndex){
        if(!runningTimeTs) {
          runningTimeTs = currPing.ts;
        }
      }else if(runningTimeTs){
        if(dur > RIDE_MAX_INTERVAL){
          stats.runningTime += (prevPing.ts - runningTimeTs);
          runningTimeTs = currPing.ts;
        }else{
          stats.runningTime += (currPing.ts - runningTimeTs);
          runningTimeTs = 0;
        }
      }

      // Total distance
      if(!initialLat && prevPing.lat){
        initialLat = prevPing.lat;
        initialLon = prevPing.lng;
      }

      if(currPing.lat && initialLat){
        stats.dst += sphericalCosinus(initialLat, initialLon, currPing.lat, currPing.lng);
        initialLat = currPing.lat;
        initialLon = currPing.lng;
      }

      if (!isSingleDayRide) {
        if ((currPing.ts * 1000) < secondDayTs) {
          stats.dayDist = stats.dst;
        }
      }
    }

    if (isSingleDayRide) {
      stats.dayDist = stats.dst;
    }

    stats.avs = stats.dst && stats.dur ? ((stats.dst / stats.dur) * (18 / 5)) : 0; // Converting m/s -> km/hr

    // console.log("computeTLStats operation finished in " + (Date.now() - sts) + " (ms) for data count(s): " + data.length);
    return stats;
  }
  catch(ex){
    console.log("Error in computeTLStats", ex);
  }
}

function computeWirelessStats(data){
  try{
    if(!data || !data.length) return;
    // let sts = Date.now();
    let stats = {
      tps: 0,
      sdt: 0,
      dst: 0,
      edt: 0,
      dur: 0,
      ec: data.length,
      avs: 0,
    };
    let initialLat = 0, initialLon = 0;
    let sumOfAllSpeedValues = 0, countOfSpeedValues = 0;

    data = data.sort((a, b) => a.ts - b.ts);
    let prevPingTs = 0;
    let currDur = 0;
    data.forEach((ping, index) => {
      if(ping.ts){
        if(!stats.sdt)
          stats.sdt = ping.ts;
        if (ping.ignition)
          stats.edt = ping.ts
      }

      if(ping.lat && ping.lng){
        if(initialLat && initialLon)
          stats.dst += sphericalCosinus(initialLat, initialLon, ping.lat, ping.lng);

        initialLat = ping.lat;
        initialLon = ping.lng;
      }

      //handle duration
      if (prevPingTs) {
        if ((ping.ts && ((ping.ts - prevPingTs) > WIRELESS_PING_DUR_THRESHOLD)) || (index === (data.length - 1))) {
          stats.dur += currDur;
          currDur = 0;
        } else
          currDur += ping.ts - prevPingTs;
      }

      if (ping.spd) {
        stats.tps = Math.max(ping.spd, stats.tps);
        sumOfAllSpeedValues += ping.spd;
        countOfSpeedValues++;
      }

      if (ping.ts) {
        prevPingTs = ping.ts;
      }
    });

    if (!stats.edt && data.length) {
      // For Ajjas Go
      stats.edt = data[data.length - 1].ts;
    }

    stats.avs = sumOfAllSpeedValues / countOfSpeedValues;// km/h

    // console.log("computeTLStats operation finished in " + (Date.now() - sts) + " (ms) for data count(s): " + data.length);
    return stats;
  } catch(e){
    console.error("Error in computeWirelessStats: ", e);
    return;
  }
}

export {
  sphericalCosinus,
  calculateBearing,
  computeTLStats,
  computeWirelessStats,
}